import * as React from 'react';
import SvgIcon from '../icons/SvgIcon';
const STARS_LIMIT = 5;
class CheckboxItem extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.createStars = (kind) => {
            let stars = [];
            for (let i = 0; i < STARS_LIMIT; i++) {
                stars.push(<SvgIcon kind={kind} className="rating__star rating__star--small" key={`${kind}_${i}`}/>);
            }
            return stars;
        };
    }
    render() {
        const { index, title, count, stars } = this.props;
        return (<div className="form-check checkbox-item">
                <input className="form-check-input" type="checkbox" value="" id={index}/>
                <label className="form-check-label" htmlFor={index}>
                    {stars && (<div className="rating mr-4">
                            <div className="rating__stars">
                                <span className="rating__stars-filled" style={{
                    width: Math.round((stars / STARS_LIMIT) * 70),
                }}>
                                    {this.createStars('Star')}
                                </span>
                                <span className="rating__stars-empty">{this.createStars('StarOutline')}</span>
                            </div>
                        </div>)}
                    {title}&nbsp;<span className="checkbox-item__badge">{count}</span>
                </label>
            </div>);
    }
}
export default CheckboxItem;
